import React from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap';
import Select from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

const SIM_NAO_OPTIONS = [
  { value: 'S', label: 'Sim' },
  { value: 'N', label: 'Não' },
];

const sectionHeaderStyle = {
  background: '#0747a6',
  color: '#fff',
  padding: '6px 12px',
  fontWeight: 700,
  fontSize: 13,
  borderRadius: '4px 4px 0 0',
};

const labelStyle = { fontSize: 12, fontWeight: 600, marginBottom: 2 };

const SecaoMoeda = ({ values, setFieldValue, temPermJurosDesc, readOnly }) => (
  <Card className="shadow-sm mb-3">
    <div style={sectionHeaderStyle}>Dados da Moeda</div>
    <Card.Body>
      <Row>
        <Col md={2} className="mb-2">
          <Form.Label style={labelStyle}>Transformação</Form.Label>
          <Select
            options={SIM_NAO_OPTIONS}
            value={SIM_NAO_OPTIONS.find((o) => o.value === values.moeda.transformacao) || null}
            onChange={(opt) => setFieldValue('moeda.transformacao', opt ? opt.value : 'N')}
            isDisabled={readOnly}
            styles={customStyles}
            components={{ DropdownIndicator }}
          />
        </Col>
        <Col md={2} className="mb-2">
          <Form.Label style={labelStyle}>Engessado</Form.Label>
          <Select
            options={SIM_NAO_OPTIONS}
            value={SIM_NAO_OPTIONS.find((o) => o.value === values.moeda.engessado) || null}
            onChange={(opt) => setFieldValue('moeda.engessado', opt ? opt.value : 'N')}
            isDisabled={readOnly}
            styles={customStyles}
            components={{ DropdownIndicator }}
          />
        </Col>
        <Col md={2} className="mb-2">
          <Form.Label style={labelStyle}>Cotação Moeda Forte</Form.Label>
          <Select
            options={SIM_NAO_OPTIONS}
            value={SIM_NAO_OPTIONS.find((o) => o.value === values.moeda.cot_mo_forte) || null}
            onChange={(opt) => setFieldValue('moeda.cot_mo_forte', opt ? opt.value : 'N')}
            isDisabled={readOnly}
            styles={customStyles}
            components={{ DropdownIndicator }}
          />
        </Col>
        {temPermJurosDesc && (
          <>
            <Col md={2} className="mb-2">
              <Form.Label style={labelStyle}>Juros Imob (%)</Form.Label>
              <Form.Control
                size="sm"
                type="number"
                step="0.000001"
                value={values.moeda.juros_imob != null ? values.moeda.juros_imob : ''}
                onChange={(e) => setFieldValue('moeda.juros_imob', e.target.value !== '' ? parseFloat(e.target.value) : null)}
                readOnly={readOnly}
              />
            </Col>
            <Col md={2} className="mb-2">
              <Form.Label style={labelStyle}>Desconto Imob (%)</Form.Label>
              <Form.Control
                size="sm"
                type="number"
                step="0.000001"
                value={values.moeda.desc_imob != null ? values.moeda.desc_imob : ''}
                onChange={(e) => setFieldValue('moeda.desc_imob', e.target.value !== '' ? parseFloat(e.target.value) : null)}
                readOnly={readOnly}
              />
            </Col>
          </>
        )}
      </Row>
    </Card.Body>
  </Card>
);

export default SecaoMoeda;
